
if ( window.navigator.userAgent.match(/(MSIE|Trident)/) ) {
    window.location.replace('/business/veralteter-browser.html');
}

import { Bootstrap } from '@shop-builder/core';
import { Configurator } from '@api/services/configurator';

import {
    ShoppingCartWidget,
    CostOverviewWidget,
    KissTariffsWidget,
    KissDevicesWidget,
    KissDeviceDetailWidget,
    KissDeviceDetailTabsWidget,
} from '@shop-builder/widgets';

async function boot(): Promise<void> {
    Configurator.stopEventListeners();

    await Configurator.sync();

    await Bootstrap.run(CostOverviewWidget);
    await Bootstrap.run(ShoppingCartWidget);

    await Bootstrap.run(KissTariffsWidget);
    await Bootstrap.run(KissDevicesWidget);
    await Bootstrap.run(KissDeviceDetailWidget);
    await Bootstrap.run(KissDeviceDetailTabsWidget);

    Configurator.resumeEventListeners();
}

if (document.readyState !== 'loading') {
    boot();
} else {
    document.addEventListener('DOMContentLoaded', async () => {
        boot();
    });
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/shop-builder/shop-builder.ts